import ActionButton from '@core/components/actionbutton/ActionButton';
import Spinner from '@core/components/spinner/Spinner';

import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';

import { useQuery, useMutation } from 'react-query';
import { companyInit, companyLeave } from 'services/company';

import { getAccessToken } from 'utils/authentication';

import { getErrorText } from 'utils/geterrortext';

import CompanyIcon from 'assets/icons/home-hashtag.svg';
import CompanyRemoveIcon from 'assets/icons/shop-remove.svg';
import WarningIcon from 'assets/icons/danger-icon.svg?url';
import NoCompanyIcon from 'assets/icons/shield-cross.svg?url';

import classes from './AccountCompanySection.module.scss';

const AccountCompanySection = () => {
	const { data, isLoading, refetch } = useQuery(
		['company-init-account', getAccessToken()],
		companyInit.GET
	);

	const {
		mutate: leaveCompanyMutate,
		isLoading: isLoadingLeaveCompany,
		error: requestError
	} = useMutation(companyLeave.POST, {
		onSuccess: () => {
			toast('You have successfully left the company.');
			destroyConfirmModal();
			refetch();
		},
		onError: (error) => {
			if (error.response.status === 409) {
				destroyConfirmModal();
				showLeaveCompanyError();
			} else {
				toast(getErrorText(error), 'Alert');
			}
		}
	});

	const {
		destroyModal: destroyConfirmModal,
		show: isConfirmVisible,
		showModal: showConfirmModal
	} = UseModal();

	const {
		destroyModal: destroyLeaveCompanyErrorModal,
		show: isLeaveCompanyErrorVisible,
		showModal: showLeaveCompanyError
	} = UseModal();

	const { toast, ToastContainer } = UseToast();

	return (
		<>
			<div className={classes['account-company-container']}>
				{data && !isLoading ? (
					<>
						{data.data.company_membership === 'lacking' ? (
							<div
								className={`${classes['request-delete-modal']} d-flex flex-column align-items-center justify-content-center gap-4 p-3 p-md-4`}>
								<img src={NoCompanyIcon} alt="warning-icon" />
								<h3>You have not joined a company yet!</h3>
								<p>
									As soon as you receive an invitation from a company and accept it, here you will
									see the details of the company and your role.
								</p>
							</div>
						) : (
							<>
								<h2 className="mb-5 mb-md-5">
									<CompanyIcon />
									My Company
								</h2>
								<div className={classes['account-company-detail']}>
									<div className="d-flex flex-row">
										<div className="d-flex flex-column">
											<p>Company Name:</p>
											<p>Role</p>
										</div>
										<div className="d-flex flex-column">
											<p>{data.data.company_name}</p>
											<p>{data.data.role_name}</p>
										</div>
									</div>
									<ActionButton kind="blank" onClick={showConfirmModal}>
										<CompanyRemoveIcon />
										Leave Company
									</ActionButton>
								</div>
							</>
						)}
					</>
				) : (
					<div className="d-flex align-items-center justify-content-center w-100 py-5">
						<Spinner />
					</div>
				)}
			</div>
			<Modal closeHandler={destroyConfirmModal} show={isConfirmVisible}>
				<div
					className={`${classes['request-delete-modal']} d-flex flex-column align-items-center justify-content-center gap-4 p-3 p-md-4`}>
					<img src={WarningIcon} alt="warning-icon" />
					<p>
						You are about to leave the <b>{data?.data?.company_name}</b> company, do you want to
						proceed ?
					</p>
					<div className="w-100 d-flex justify-content-end mt-3">
						<ActionButton kind="simple" onClick={destroyConfirmModal}>
							Cancel
						</ActionButton>
						<ActionButton loading={isLoadingLeaveCompany} onClick={leaveCompanyMutate}>
							Confirm
						</ActionButton>
					</div>
				</div>
			</Modal>
			<Modal
				show={isLeaveCompanyErrorVisible}
				closeHandler={destroyLeaveCompanyErrorModal}
				title={'Delete Account'}>
				<div
					className={`${classes['request-delete-modal']} d-flex flex-column align-items-center justify-content-center gap-4 p-3 p-md-4`}>
					<img src={WarningIcon} alt="warning-icon" />
					<h3>{requestError?.response?.data?.message}</h3>
					<p>{requestError?.response?.data?.sub_message}</p>
					<div className="w-100 d-flex justify-content-end mt-3">
						<ActionButton kind="simple" onClick={destroyLeaveCompanyErrorModal}>
							ok
						</ActionButton>
					</div>
				</div>
			</Modal>
			<ToastContainer />
		</>
	);
};

export default AccountCompanySection;
